import {Component} from '@angular/core';
import {MatDialog, MatDialogRef, MatDialogConfig} from '@angular/material/dialog';

@Component({ standalone: false,
    selector: 'irb-common-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
    dialogRef: MatDialogRef<any>;

    constructor(public md: MatDialog) {
    }

    open(type: any, dialogConfig?: MatDialogConfig): MatDialogRef<any> {
        if (!dialogConfig) {
            dialogConfig = this.getDefaultConfig();
        }

        const dialogRef = this.md.open(type, dialogConfig);
        this.dialogRef = dialogRef;
        return dialogRef;
    }

    getDefaultConfig(): MatDialogConfig {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        return dialogConfig;
    }
}
